




















import { Component } from 'vue-property-decorator';
// import { LendingRevolvingCreditModule } from '@/store/Accounts/LendingRevolvingCreditModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'LendingRevolvingCreditInstalmentPlanSettingsCreate' })
export default class extends SaascadaVue {

    get productVM() {
        return {
            instalmentPlanSettings: {}
        };
        //return LendingRevolvingCreditModule.createProductViewModel;
    }

}
